import React from "react";
import { noImage, proSportFront } from "../../resources/images";
import { Img } from "react-image";

const ItemImage = ({ imgSrc, isSmall, width, height , paddding="5px" }) => {
  const hw = `${isSmall ? 18 : 40}px`;
  return (
    <span
      style={{
        display: "flex",
      }}
    >
      <Img
        style={{
          height: height ?? hw,
          width: width ?? hw,
          borderRadius: "50%",
          padding: paddding,
        }}
        src={[imgSrc , noImage]}
      />
    </span>
  );
};

export { ItemImage };
